import iconRules from '../../icon/feature';

const light = (params) => iconRules.light(params);

export default light;
